// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"232":"2bfefc0d","629":"2bfefc0d"}[chunkId] + ".chunk.css";
};